/*
 * @Author: Claude
 * @Date: 2025-11-08
 * @Description: 文件大小校验工具（统一使用 KB 作为单位）
 */

import { t } from '@/utils/helper/intl';

/**
 * 格式化文件大小为可读字符串
 * @param bytes - 字节数
 * @returns 格式化的大小字符串，如 "1.5MB" 或 "500KB"
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0B';

  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))}${sizes[i]}`;
};

/**
 * 校验文件大小是否在范围内
 * @param file - 文件对象
 * @param minSize - 最小大小（B）
 * @param maxSize - 最大大小（B）
 * @returns 错误信息或 null
 */
export const validateFileSize = (
  file: File,
  minSize?: number,
  maxSize?: number,
): string | null => {
  const fileSize = file.size;
  const currentSize = formatFileSize(fileSize);

  if (minSize !== undefined && fileSize < minSize) {
    return t('minSizeKB-currentSize', {
      minSize: formatFileSize(minSize),
      currentSize,
    });
  }

  if (maxSize !== undefined && fileSize > maxSize) {
    return t('$maxSizeKB-$formatFileSizefile-sizeKB', {
      maxSize: formatFileSize(maxSize),
      currentSize,
    });
  }

  return null;
};
